import React from 'react';

export const ErrorPage: React.FC = () => {
  return <div>Invalid path</div>;
};
